'use client'

import { useMediaState } from '@7f-ui/hooks/use-media-state'

import { hotelAdsCriticalPath } from './nav'

type Viewport = 'mobile' | 'desktop'

export function useHotelAdsCriticalPath(order: number, viewport: Viewport, enabled = true) {
  const isMobile = useMediaState('mobile')
  const isActiveViewport = viewport === 'mobile' ? isMobile : !isMobile

  return enabled && isActiveViewport ? hotelAdsCriticalPath(order) : {}
}
